import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import defaultCardImage from "images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomizeIconImage from "images/customize-icon.svg";
import FastIconImage from "images/fast-icon.svg";
import ReliableIconImage from "images/reliable-icon.svg";
import SimpleIconImage from "images/simple-icon.svg";
import i18n from "helpers/i18n";

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-100 leading-loose`}
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default ({
  cards = null,
  heading = "Amazing Features",
  subheading = "Features",
  description = i18n.t(
    "Từ lọc hội thoại đến chuẩn bị nội dung và xem kết quả, bạn kiểm soát từng bước của đợt gửi."
  ),
}) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const defaultCards = [
    {
      imageSrc: ShieldIconImage,
      title: i18n.t("Quản lý dữ liệu"),
      description: i18n.t(
        "Tệp khách hàng được lưu trong trình duyệt. Thông tin liên hệ, kích hoạt và thanh toán được xử lý để cung cấp dịch vụ."
      ),
    },
    {
      imageSrc: SupportIconImage,
      title: i18n.t("Liên hệ hỗ trợ"),
      description: i18n.t(
        "Liên hệ qua kênh hỗ trợ để được hướng dẫn cài đặt, kích hoạt và lựa chọn gói."
      ),
    },
    {
      imageSrc: CustomizeIconImage,
      title: i18n.t("Bộ Lọc Đa Dạng"),
      description: i18n.t(
        "Lọc danh sách theo dữ liệu hội thoại trên Facebook hoặc Pancake để chọn nhóm người nhận phù hợp."
      ),
    },
    {
      imageSrc: ReliableIconImage,
      title: i18n.t("Nhập và xuất tệp"),
      description: i18n.t(
        "Dễ dàng tải xuống / tải lên tệp khách hàng của bạn."
      ),
    },
    {
      imageSrc: FastIconImage,
      title: i18n.t("Theo dõi kết quả"),
      description: i18n.t(
        "Xem trạng thái gửi thành công hoặc lỗi, tạm dừng và tiếp tục đợt gửi khi cần."
      ),
    },
    {
      imageSrc: SimpleIconImage,
      title: i18n.t("Chủ động nội dung"),
      description: i18n.t("Chuẩn bị tin nhắn, chọn người nhận và kiểm tra trước khi bắt đầu gửi."),
    },
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container id="features">
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description ||
                    "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
        <a href="/privacy" tw="mt-6 font-semibold text-primary-500 hover:underline">
          {i18n.t("Xem chính sách dữ liệu")}
        </a>
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
